var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCa = function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.012 0h22.642v32H10.012V0z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.31 0h11.322v32h-11.32V0zM32.655 0h11.32v32h-11.32V0zM13.398 15.463l-.88.3 4.092 3.59c.31.923-.107 1.195-.373 1.68l4.44-.565-.115 4.47.92-.026-.2-4.432 4.445.527c-.275-.58-.52-.89-.265-1.82l4.088-3.4-.715-.26c-.585-.45.253-2.174.38-3.26 0 0-2.388.82-2.545.39l-.608-1.168-2.172 2.385c-.237.057-.338-.038-.394-.238L24.5 8.652l-1.59.894c-.133.057-.266.008-.354-.147l-1.528-3.067-1.576 3.184c-.12.114-.238.127-.336.05l-1.513-.85.908 4.947c-.07.196-.244.252-.448.145l-2.076-2.36c-.272.435-.456 1.146-.815 1.305-.358.15-1.56-.3-2.366-.477.275.993 1.136 2.644.59 3.185z",
    fill: "#BF0A30"
  })));
};
export default SvgCa;